/**
 * Contact Form Component
 */

document.addEventListener('DOMContentLoaded', function() {
    const contactForm = document.getElementById('fluidic-contact-form');
    const newsletterForm = document.getElementById('fluidic-newsletter-form');

    // Máscaras de telefone
    if (contactForm && typeof jQuery !== 'undefined' && jQuery.fn.mask) {
        const phoneInput = contactForm.querySelector('input[name="phone"]');
        if (phoneInput) {
            jQuery(phoneInput).mask('(00) 00000-0000');
        }
    }

    /**
     * Função para criar mensagem de feedback
     */
    function createMessageElement(message, type) {
        const messageEl = document.createElement('div');
        messageEl.className = `form-message form-message--${type}`;
        messageEl.textContent = message;
        return messageEl;
    }

    /**
     * Função para remover mensagens existentes
     */
    function removeMessages(form) {
        // Remover mensagens dentro do formulário
        const existingMessages = form.querySelectorAll('.form-message');
        existingMessages.forEach(msg => msg.remove());
        
        // Para newsletter, também remover mensagens após o formulário
        if (form.id === 'fluidic-newsletter-form') {
            const container = form.closest('.container-fluidic');
            if (container) {
                const containerMessages = container.querySelectorAll('.form-message');
                containerMessages.forEach(msg => msg.remove());
            } else {
                const parentMessages = form.parentElement.querySelectorAll('.form-message');
                parentMessages.forEach(msg => msg.remove());
            }
        }
    }

    /**
     * Função para mostrar mensagem
     */
    function showMessage(form, message, type) {
        removeMessages(form);
        const messageEl = createMessageElement(message, type);
        
        // Para newsletter, inserir após o formulário (dentro do container)
        // Para contato, inserir no início do formulário
        if (form.id === 'fluidic-newsletter-form') {
            const container = form.closest('.container-fluidic');
            if (container) {
                container.appendChild(messageEl);
            } else {
                form.parentElement.appendChild(messageEl);
            }
        } else {
            form.insertBefore(messageEl, form.firstChild);
        }
        
        // Scroll para a mensagem
        messageEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        
        // Remover mensagem após 5 segundos
        setTimeout(() => {
            messageEl.remove();
        }, 5000);
    }

    /**
     * Função para validar campo
     */
    function validateField(field) {
        const value = field.value.trim();
        const isRequired = field.hasAttribute('required');
        const type = field.type;
        
        // Remover classes de erro anteriores
        field.classList.remove('has-error');
        
        // Remover mensagens de erro existentes (procurar no wrapper ou parent)
        const wrapper = field.closest('.newsletter-form__field-wrapper') || field.closest('.contato-form__group') || field.parentElement;
        const errorMsg = wrapper.querySelector('.field-error');
        if (errorMsg) {
            errorMsg.remove();
        }

        // Validação de campo obrigatório
        if (isRequired && !value) {
            field.classList.add('has-error');
            const errorEl = document.createElement('span');
            errorEl.className = 'field-error';
            errorEl.textContent = 'Este campo é obrigatório';
            wrapper.appendChild(errorEl);
            return false;
        }

        // Validação de email
        if (type === 'email' && value) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                field.classList.add('has-error');
                const errorEl = document.createElement('span');
                errorEl.className = 'field-error';
                errorEl.textContent = 'Por favor, insira um e-mail válido';
                wrapper.appendChild(errorEl);
                return false;
            }
        }

        return true;
    }

    /**
     * Função para validar formulário completo
     */
    function validateForm(form) {
        // Buscar todos os campos obrigatórios (inputs e textareas)
        const requiredFields = form.querySelectorAll('input[required], textarea[required]');
        let isValid = true;

        // Se não encontrou campos obrigatórios, retornar true (formulário sem campos obrigatórios)
        if (requiredFields.length === 0) {
            return true;
        }

        // Validar cada campo
        requiredFields.forEach(field => {
            const fieldValid = validateField(field);
            if (!fieldValid) {
                isValid = false;
            }
        });

        return isValid;
    }

    /**
     * Função para setar estado de loading
     */
    function setLoadingState(form, isLoading) {
        const submitButton = form.querySelector('button[type="submit"]');
        const allInputs = form.querySelectorAll('input, textarea, button');
        
        if (submitButton) {
            if (isLoading) {
                submitButton.disabled = true;
                submitButton.dataset.originalText = submitButton.textContent;
                submitButton.textContent = 'Enviando...';
                submitButton.classList.add('is-loading');
            } else {
                submitButton.disabled = false;
                submitButton.textContent = submitButton.dataset.originalText || submitButton.textContent;
                submitButton.classList.remove('is-loading');
            }
        }

        allInputs.forEach(input => {
            if (input !== submitButton) {
                input.disabled = isLoading;
            }
        });
    }

    // Validação em tempo real para formulário de contato
    if (contactForm) {
        const fields = contactForm.querySelectorAll('input, textarea');
        fields.forEach(field => {
            field.addEventListener('blur', function() {
                validateField(field);
            });

            field.addEventListener('input', function() {
                if (field.classList.contains('has-error')) {
                    validateField(field);
                }
            });
        });

        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();

            // Limpar erros anteriores
            const allFields = contactForm.querySelectorAll('input, textarea');
            allFields.forEach(field => {
                field.classList.remove('has-error');
                const wrapper = field.closest('.contato-form__group') || field.parentElement;
                const errorMsg = wrapper.querySelector('.field-error');
                if (errorMsg) {
                    errorMsg.remove();
                }
            });

            // Buscar campos diretamente
            const nameField = contactForm.querySelector('input[name="name"]');
            const lastnameField = contactForm.querySelector('input[name="lastname"]');
            const emailField = contactForm.querySelector('input[name="email"]');
            const phoneField = contactForm.querySelector('input[name="phone"]');
            const messageField = contactForm.querySelector('textarea[name="message"]');
            
            // Validar campos diretamente
            let hasErrors = false;
            
            if (!nameField || !nameField.value.trim()) {
                if (nameField) {
                    nameField.classList.add('has-error');
                    const wrapper = nameField.closest('.contato-form__group') || nameField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Este campo é obrigatório';
                    wrapper.appendChild(errorEl);
                }
                hasErrors = true;
            }
            
            if (!lastnameField || !lastnameField.value.trim()) {
                if (lastnameField) {
                    lastnameField.classList.add('has-error');
                    const wrapper = lastnameField.closest('.contato-form__group') || lastnameField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Este campo é obrigatório';
                    wrapper.appendChild(errorEl);
                }
                hasErrors = true;
            }
            
            if (!emailField || !emailField.value.trim()) {
                if (emailField) {
                    emailField.classList.add('has-error');
                    const wrapper = emailField.closest('.contato-form__group') || emailField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Este campo é obrigatório';
                    wrapper.appendChild(errorEl);
                }
                hasErrors = true;
            } else if (emailField && emailField.value.trim()) {
                // Validar formato de email
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(emailField.value.trim())) {
                    emailField.classList.add('has-error');
                    const wrapper = emailField.closest('.contato-form__group') || emailField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Por favor, insira um e-mail válido';
                    wrapper.appendChild(errorEl);
                    hasErrors = true;
                }
            }
            
            if (!phoneField || !phoneField.value.trim()) {
                if (phoneField) {
                    phoneField.classList.add('has-error');
                    const wrapper = phoneField.closest('.contato-form__group') || phoneField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Este campo é obrigatório';
                    wrapper.appendChild(errorEl);
                }
                hasErrors = true;
            }
            
            if (!messageField || !messageField.value.trim()) {
                if (messageField) {
                    messageField.classList.add('has-error');
                    const wrapper = messageField.closest('.contato-form__group') || messageField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Este campo é obrigatório';
                    wrapper.appendChild(errorEl);
                }
                hasErrors = true;
            }
            
            if (hasErrors) {
                showMessage(contactForm, 'Por favor, preencha todos os campos obrigatórios corretamente.', 'error');
                return;
            }

            // Setar estado de loading
            setLoadingState(contactForm, true);
            removeMessages(contactForm);

            // Criar FormData manualmente para garantir que os dados sejam coletados
            const formData = new FormData();
            formData.append('name', nameField.value.trim());
            formData.append('lastname', lastnameField.value.trim());
            formData.append('email', emailField.value.trim());
            formData.append('phone', phoneField.value.trim());
            formData.append('message', messageField.value.trim());
            formData.append('action', 'fluidic_contact_form');
            
            // Verificar se fluidicAjax está definido
            if (typeof fluidicAjax === 'undefined') {
                setLoadingState(contactForm, false);
                showMessage(contactForm, 'Erro de configuração. Por favor, recarregue a página.', 'error');
                return;
            }
            
            formData.append('nonce', fluidicAjax.nonce);

            fetch(fluidicAjax.ajaxurl, {
                method: 'POST',
                body: formData,
            })
            .then(response => response.json())
            .then(data => {
                setLoadingState(contactForm, false);
                
                if (data.success) {
                    contactForm.reset();
                    showMessage(contactForm, data.data.message, 'success');
                } else {
                    showMessage(contactForm, data.data.message || 'Erro ao enviar mensagem. Tente novamente.', 'error');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoadingState(contactForm, false);
                showMessage(contactForm, 'Erro ao enviar mensagem. Tente novamente.', 'error');
            });
        });
    }

    // Validação em tempo real para formulário de newsletter
    if (newsletterForm) {
        const fields = newsletterForm.querySelectorAll('input');
        fields.forEach(field => {
            field.addEventListener('blur', function() {
                validateField(field);
            });

            field.addEventListener('input', function() {
                if (field.classList.contains('has-error')) {
                    validateField(field);
                }
            });
        });

        newsletterForm.addEventListener('submit', function(e) {
            e.preventDefault();

            // Limpar erros anteriores
            const allFields = newsletterForm.querySelectorAll('input');
            allFields.forEach(field => {
                field.classList.remove('has-error');
                const wrapper = field.closest('.newsletter-form__field-wrapper') || field.parentElement;
                const errorMsg = wrapper.querySelector('.field-error');
                if (errorMsg) {
                    errorMsg.remove();
                }
            });

            // Buscar campos diretamente
            const nameField = newsletterForm.querySelector('input[name="name"]');
            const emailField = newsletterForm.querySelector('input[name="email"]');
            
            // Validar campos diretamente
            let hasErrors = false;
            
            if (!nameField || !nameField.value.trim()) {
                if (nameField) {
                    nameField.classList.add('has-error');
                    const wrapper = nameField.closest('.newsletter-form__field-wrapper') || nameField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Este campo é obrigatório';
                    wrapper.appendChild(errorEl);
                }
                hasErrors = true;
            }
            
            if (!emailField || !emailField.value.trim()) {
                if (emailField) {
                    emailField.classList.add('has-error');
                    const wrapper = emailField.closest('.newsletter-form__field-wrapper') || emailField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Este campo é obrigatório';
                    wrapper.appendChild(errorEl);
                }
                hasErrors = true;
            } else if (emailField && emailField.value.trim()) {
                // Validar formato de email
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(emailField.value.trim())) {
                    emailField.classList.add('has-error');
                    const wrapper = emailField.closest('.newsletter-form__field-wrapper') || emailField.parentElement;
                    const errorEl = document.createElement('span');
                    errorEl.className = 'field-error';
                    errorEl.textContent = 'Por favor, insira um e-mail válido';
                    wrapper.appendChild(errorEl);
                    hasErrors = true;
                }
            }
            
            if (hasErrors) {
                showMessage(newsletterForm, 'Por favor, preencha todos os campos obrigatórios corretamente.', 'error');
                return;
            }

            // Setar estado de loading
            setLoadingState(newsletterForm, true);
            removeMessages(newsletterForm);

            // Criar FormData manualmente para garantir que os dados sejam coletados
            const formData = new FormData();
            formData.append('name', nameField.value.trim());
            formData.append('email', emailField.value.trim());
            formData.append('action', 'fluidic_newsletter');
            
            // Verificar se fluidicAjax está definido
            if (typeof fluidicAjax === 'undefined') {
                setLoadingState(newsletterForm, false);
                showMessage(newsletterForm, 'Erro de configuração. Por favor, recarregue a página.', 'error');
                return;
            }
            
            formData.append('nonce', fluidicAjax.nonce);

            fetch(fluidicAjax.ajaxurl, {
                method: 'POST',
                body: formData,
            })
            .then(response => response.json())
            .then(data => {
                setLoadingState(newsletterForm, false);
                
                if (data.success) {
                    newsletterForm.reset();
                    showMessage(newsletterForm, data.data.message, 'success');
                } else {
                    showMessage(newsletterForm, data.data.message || 'Erro ao cadastrar. Tente novamente.', 'error');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoadingState(newsletterForm, false);
                showMessage(newsletterForm, 'Erro ao cadastrar. Tente novamente.', 'error');
            });
        });
    }
});
